var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75146 2C2.75146 2.75855 2.13519 3.37572 1.37573 3.37572C0.617177 3.37572 0 2.75946 0 2C0 1.24144 0.616266 0.624268 1.37573 0.624268C2.13428 0.624268 2.75146 1.24142 2.75146 2Z",
    fill: "#1D1D1D",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37585 2C7.37585 2.75855 6.75958 3.37572 6.00012 3.37572C5.24157 3.37572 4.62439 2.75946 4.62439 2C4.62439 1.24144 5.24066 0.624268 6.00012 0.624268C6.75867 0.624268 7.37585 1.24142 7.37585 2Z",
    fill: "#1D1D1D",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12 2.75943 11.3837 3.37572 10.6243 3.37572C9.8648 3.37572 9.24854 2.75946 9.24854 2C9.24854 1.24053 9.8648 0.624268 10.6243 0.624268C11.3837 0.624268 12 1.24053 12 2Z",
    fill: "#1D1D1D",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisIcon);
export default __webpack_public_path__ + "static/media/ellipsis_icon.1c28f4d49be7f86de5167ae503550b95.svg";
export { ForwardRef as ReactComponent };